import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Offcanvas, Dropdown, Badge } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom"; // Link import edildi
import { supabase } from "../supabaseClient/supabaseClient";
import logo from "../assets/icons/logo.png";
import { useCart } from "../hooks/useCart"; // Sepet hook'u
// Icons
import { FaShoppingCart, FaUserCircle, FaCreditCard, FaSignOutAlt } from "react-icons/fa";
import "./Header.css"; // CSS dosyasını import ediyoruz

function Header({ session }) {
  const [showMenu, setShowMenu] = useState(false);
  const [subscription, setSubscription] = useState(null);

  const navigate = useNavigate();
  const { cart } = useCart(); // Sepet verisi

  // Abonelik bilgisini çek
  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const { data, error } = await supabase
          .from('subscriptions')
          .select('*')
          .eq('user_id', session.user.id)
          .eq('status', 'active')
          .order('end_date', { ascending: false }) // En son biten aboneliği al
          .limit(1)
          .single();

        if (error && error.code !== 'PGRST116') { // PGRST116: no rows found
          console.error("Abonelik hatası:", error);
        }

        if (data) {
          setSubscription(data);
        }
      } catch (err) {
        console.error("Bilinmeyen hata:", err);
      }
    };

    if (session?.user) {
      fetchSubscription();
    } else {
      setSubscription(null);
    }
  }, [session]);

  // Çıkış Yap Fonksiyonu
  const handleLogout = async (e) => {
    if (e) e.preventDefault();
    try {
      await supabase.auth.signOut();
      handleClose(); // Menüyü kapat
      window.location.href = "/"; // Tüm state'lerin temizlenmesi için tam sayfa yenileme ile ana sayfaya dön
    } catch (error) {
      console.error("Çıkış yaparken hata oluştu:", error);
    }
  };

  // Menüyü kapatma yardımcı fonksiyonu (Linklere tıklanınca kapanması için)
  const handleClose = () => setShowMenu(false);
  const handleShow = () => setShowMenu(true);

  // Menü Elemanları (Tek yerden yönetim)
  const menuItems = [
    { label: "Anasayfa", path: "/Index" },
    { label: "Projeler", path: "/Projeler" },
    { label: "Hakkımızda", path: "/Hakkimizda" },
    { label: "Kurumsal İlkeler", path: "/Kurumsal" },
    { label: "İletişim", path: "/İletisim" },
    { label: "Paketler", path: "/SatinAl" },
  ];

  // Tarih formatla
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('tr-TR', options);
  };

  // Auth / Profil Bölümü
  const AuthSection = () => {
    if (session) {
      const userName = session.user.user_metadata?.full_name || session.user.email;
      const daysLeft = subscription
        ? Math.ceil((new Date(subscription.end_date) - new Date()) / (1000 * 60 * 60 * 24))
        : 0;

      return (
        <div className="d-flex align-items-center gap-3 profile-section">
          {/* Sepet İkonu */}
          <Link to="/Sepet" className="cart-icon-container" onClick={handleClose} title="Sepetim">
            <FaShoppingCart size={22} color="#001f3f" />
            {cart.length > 0 && (
              <Badge bg="danger" pill className="cart-badge">
                {cart.length}
              </Badge>
            )}
          </Link>

          {/* Profil Dropdown */}
          <Dropdown align="end">
            <Dropdown.Toggle variant="light" id="dropdown-basic" className="profile-dropdown-btn">
              <div className="d-flex align-items-center gap-2">
                <FaUserCircle size={28} color="#001f3f" />
                <div className="d-none d-md-block text-start">
                  <div className="profile-name">{userName}</div>
                  <div className="profile-sub-text">
                    {subscription ? (
                      <span className="text-success" style={{ fontSize: "0.75rem", fontWeight: "bold" }}>
                        {daysLeft > 0 ? `${daysLeft} gün kaldı` : "Süresi doldu"}
                      </span>
                    ) : (
                      <span className="text-secondary" style={{ fontSize: "0.75rem" }}>Üyelik Yok</span>
                    )}
                  </div>
                </div>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="profile-dropdown-menu">
              <div className="px-3 py-2 border-bottom mb-2 d-md-none">
                <strong>{userName}</strong>
                <div className="small text-muted">{session.user.email}</div>
              </div>

              {subscription && (
                <Dropdown.ItemText className="text-muted small">
                  Bitiş: {formatDate(subscription.end_date)}
                </Dropdown.ItemText>
              )}

              <Dropdown.Item as={Link} to="/Profil" onClick={handleClose}>
                <FaUserCircle className="me-2" /> Hesabım
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/SatinAl" onClick={handleClose}>
                <FaCreditCard className="me-2" /> Paket Yükselt
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={handleLogout} className="text-danger">
                <FaSignOutAlt className="me-2" /> Çıkış Yap
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      );
    } else {
      return (
        <div className="d-flex gap-2">
          <Link to="/Uyegirisi" className="auth-btn" onClick={handleClose}>
            ÜYE GİRİŞİ
          </Link>
          <Link to="/Uyeol" className="auth-btn" onClick={handleClose}>
            ÜYE OL
          </Link>
        </div>
      );
    }
  };

  return (
    <Navbar expand="lg" className="custom-navbar" sticky="top">
      <Container fluid>
        {/* LOGO */}
        <Navbar.Brand as={Link} to="/Index" className="d-flex align-items-center me-auto">
          <img src={logo} alt="STAI Logo" className="brand-logo" />
        </Navbar.Brand>

        {/* MOBILE CART ICON (Visible only on small screens) */}
        <div className="d-lg-none me-2 d-flex align-items-center gap-2">
          {/* Satın Al kısa yol butonu */}
          <Link
            to="/SatinAl"
            style={{
              background: '#001f3f',
              color: '#fff',
              fontWeight: 700,
              fontSize: '0.72rem',
              letterSpacing: '0.4px',
              textTransform: 'uppercase',
              padding: '6px 14px',
              borderRadius: '50px',
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              boxShadow: '0 2px 8px rgba(0,31,63,0.25)',
              lineHeight: 1.4
            }}
          >
            Satın Al
          </Link>

          <Link to="/Sepet" className="cart-icon-container" style={{ marginRight: 0 }}>
            <FaShoppingCart size={20} color="#001f3f" />
            {cart.length > 0 && (
              <Badge bg="danger" pill className="cart-badge" style={{ fontSize: '0.6rem' }}>
                {cart.length}
              </Badge>
            )}
          </Link>
        </div>

        {/* HAMBURGER BUTONU */}
        <Navbar.Toggle
          aria-controls="offcanvasNavbar"
          onClick={handleShow}
          style={{
            background: "#001f3f",
            border: "none",
            borderRadius: "8px",
            padding: "8px 12px",
            boxShadow: "0 2px 8px rgba(0,31,63,0.3)"
          }}
          children={
            <span style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
              <span style={{ display: "block", width: 22, height: 2.5, background: "#fff", borderRadius: 2 }} />
              <span style={{ display: "block", width: 16, height: 2.5, background: "#fff", borderRadius: 2 }} />
              <span style={{ display: "block", width: 22, height: 2.5, background: "#fff", borderRadius: 2 }} />
            </span>
          }
        />

        {/* OFFCANVAS MENÜ */}
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          show={showMenu}
          onHide={handleClose}
          className="offcanvas-custom"
        >
          <Offcanvas.Header closeButton className="offcanvas-header-custom">
            <Offcanvas.Title id="offcanvasNavbarLabel" className="offcanvas-title">
              Menü
            </Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3 align-items-center">
              {/* Dinamik Menü Linkleri */}
              {menuItems.map((item, index) => (
                <Nav.Link
                  key={index}
                  as={Link}
                  to={item.path}
                  className="nav-link-custom"
                  onClick={handleClose}
                >
                  {item.label}
                </Nav.Link>
              ))}

              {/* Login/Profil Alanı */}
              <div className="auth-buttons-container ms-3 d-none d-lg-block">
                <AuthSection />
              </div>

              {/* Mobile Menu Footer (for Auth buttons if needed inside menu on mobile, 
                   but we are keeping it consistent. The AuthSection is hidden on mobile inside the list 
                   because we want to rework it or keep it simple. 
                   Actually, let's show AuthSection inside menu for mobile too, 
                   but we already put Cart icon outside. 
                   Let's make sure AuthSection renders correctly in mobile menu.)
               */}
              <div className="d-lg-none mt-3 w-100 border-top pt-3">
                <AuthSection />
              </div>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
}

export default Header;
